
import { useState, useEffect } from "react";
import { useIsMobile } from "@/hooks/use-mobile";

export const HeroHeader = () => {
  const businessTypes = [
    "MEDICAL SPA", 
    "DAY SPA",
    "BEAUTY SALON",
    "MASSAGE CLINIC"
  ];
  
  const [currentIndex, setCurrentIndex] = useState(0);
  const isMobile = useIsMobile();
  
  useEffect(() => {
    // Set up rotation interval
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % businessTypes.length);
    }, 3000); // Change every 3 seconds
    
    // Clean up interval on unmount
    return () => clearInterval(interval);
  }, []);

  return (
    <header className="space-y-4">
      <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold text-brutal-black leading-tight font-mono uppercase relative">
        <span className="block transform hover:scale-105 transition-transform duration-300">
          THE VOICE ASSISTANT
        </span>
        <span className="block">
          FOR YOUR
        </span>
        <span className="block relative px-2 md:px-4">
          <span className="absolute -inset-1 bg-brutal-gray blur opacity-30"></span>
          <span className="inline-block w-full text-center overflow-hidden">
            <span className="inline-block animate-fade-in text-2xl md:text-4xl lg:text-7xl tracking-tight md:tracking-normal">
              {businessTypes[currentIndex]}
            </span>
          </span>
        </span>
        <div className="absolute -right-4 -top-4 w-20 h-20 border-4 border-brutal-black rotate-12 bg-brutal-dark opacity-20 hidden md:block"></div>
        <div className="absolute -left-4 -bottom-4 w-16 h-16 border-4 border-brutal-black -rotate-12 bg-brutal-gray opacity-20 hidden md:block"></div>
      </h1>
    </header>
  );
};
